import type { MovementType } from '../characters/types';
import type { Fighter, TileDef } from './types';

/**
 * Whether a tile's hazard reaches a fighter that moves so. It burns what stands in it; a flier
 * passes over unharmed (THE_DECISION_TABLE #1: the owner's words in D-43 are "any character
 * walking on lava").
 */
export function hazardReaches(tile: TileDef, movement: MovementType): boolean {
  return (tile.damagePerSecond ?? 0) > 0 && movement !== 'fly';
}

/**
 * Hit points a second a tile takes from a fighter standing in it: its rate, slowed in proportion
 * to the fighter's resistance to its kind of harm (D-43: lava takes 1 a second, less by fire
 * resistance). A hazard of no named kind is resisted by nothing.
 */
export function hazardRate(tile: TileDef, f: Pick<Fighter, 'movement' | 'resistances'>): number {
  if (!hazardReaches(tile, f.movement)) return 0;
  const resistance = tile.damageType ? (f.resistances[tile.damageType] ?? 0) : 0;
  return Math.max(0, (tile.damagePerSecond ?? 0) * (1 - Math.min(1, resistance)));
}
